class EventsList {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.eventsList')

    if (!this.section)
      return

    this.buttons      = this.section.querySelectorAll('.eventsList__button')
    this.itemsWrapper = this.section.querySelector('.eventsList__items')
    this.items        = this.itemsWrapper.querySelectorAll('.eventsList__item')

    return true

  }

  setEvents() {

    this.buttons.each((item, index) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.setItem(index)
        $('.postItem').show();
        $('.no-on-culture-' + index).hide();
        $('.content__postsMore').attr('href', 'news#news_left_id_' + $('#news_link_id_' + index).val());
      })

    })

  }

  setItem(index) {

    const category = this.buttons[index].getAttribute('data-category')
    const items    = this.itemsWrapper.querySelectorAll('.eventsList__item[data-category="' + category + '"]')

    this.buttons.removeClass('eventsList__button--active')
    this.buttons[index].addClass('eventsList__button--active')

    this.items.removeClass('eventsList__item--active')
    items.addClass('eventsList__item--active')

  }

}
